/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/OPDPackageParticularHospitalState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 11:05:49 am                          *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */


 import Fuse from 'fuse.js';
 import { axios_auth_instance_hba_customer, base_axios_instance_hospital_customer } from '../utils/axios_utils';
 const initialState = {
     fetchingHospitalInfo: true,
     fetchedHospitalInfoSuccess: false,
     fetchingData: true,
     fetchedSuccessfuly: false,
     hospitalInfo: null,
     packageList: [],
     shownPackageList: [],
     hospitalList: [],
     filterRegions: [],
     filteredPackageList: [],
     showHospitalList: [],
     filterdSpeciality: [],
 };
 
 const OPDPackageParticularHospitalState = {
     namespaced: true,  
     state() {
         return initialState;
     },
     getters: {
         getFilteredPackageList(state) {
             return state.filteredPackageList;
         },
         getNonfilteredPackageList(state) {
             return state.packageList;
         },
     },
     mutations: {
         makeFetchingDataTrue(state) {
             state.fetchingData = true;
         },
         makeFetchingDataFalse(state) {
             state.fetchingData = false;
         },
         makeFetchedSuccessFulyTrue(state) {
             state.fetchedSuccessfuly = true;
         },
         makeFetchingHospitalDataTrue(state) {
            state.fetchingHospitalInfo = true;
        },
        makeFetchingHospitalDataFalse(state) {
            state.fetchingHospitalInfo = false;
        },
        makeFetchedHospitalSuccessFulyTrue(state) {
            state.fetchedHospitalInfoSuccess = true;
        },
         uploadPackageList(state, packageList) {
             state.packageList = packageList;
         },
         uploadHospitalInfo(state, hospitalData) {
            state.hospitalInfo = hospitalData;
        },
         uploadfilteredPackageList(state, packageList) {
             state.filteredPackageList = packageList;
         },
         uploadShownPackageList(state, packageList) {
             state.shownPackageList = packageList;
         },
         uploadRegionFilter(state, regions) {
             state.filterRegions = regions;
         },
         uploadSpecialityFilter(state, speciality) {
            state.filterdSpeciality = speciality;
        },
        resetState(state) {
             Object.keys(initialState).forEach(key => {
                 state[key] = initialState[key];
             });
         }
     },
     actions: {
        async loadHospitalInfo(context, payload) {
            try {
                let apiResponse = await axios_auth_instance_hba_customer.get(`/opd/viewHospital/${payload.hospitalRegNumber}`);
                let hospitalInfo = apiResponse.data.hospitalData;
                context.commit('uploadHospitalInfo', hospitalInfo);
                context.commit('makeFetchingHospitalDataFalse');
            } catch (error) {
                console.log('Error While fetching hospital info', error);
            }
        },
        async loadPackageList(context, payload) {
            try {
                context.commit('makeFetchingDataTrue');
                let apiResponse = await axios_auth_instance_hba_customer.get(`/package/viewHospital/${payload.hospitalRegNumber}`)
                let data = apiResponse.data.packageList;
                setTimeout(() => {
                    context.commit('makeFetchingDataFalse');
                    context.commit('makeFetchedSuccessFulyTrue');
                    context.commit('uploadPackageList', data);
                    context.commit('uploadfilteredPackageList', data);
                    context.commit('uploadShownPackageList', data);
                }, 2000)            
            } catch (error) {
                console.log('Error while loadPackageList in OPDPackageParticularHospitalState', error);
            }
        },
        async addPackageSpecialityFilter(context, payload) {
            try {
                let actualPackageList = context.getters.getNonfilteredPackageList;
                let selectedSpecialityIdList = payload.specialities;
                context.commit('uploadSpecialityFilter', selectedSpecialityIdList);
                selectedSpecialityIdList = selectedSpecialityIdList.map((item) => (item.id));
                if (selectedSpecialityIdList.length != 0) {
                    actualPackageList = actualPackageList.filter((item) => (selectedSpecialityIdList.includes(item.packageInfo.category)));
                }
                context.commit('uploadfilteredPackageList', actualPackageList);
                context.commit('uploadShownPackageList', actualPackageList);
            } catch (error) {
                console.log('Error While fetching hospital info', error);
            }
        },
     },
 };
 export default OPDPackageParticularHospitalState;